import { makeAutoObservable } from 'mobx'
import { toJS } from 'mobx'

import { MainPageExcursions } from 'shared/api/excursions/main-page'

import { PopularDirectionExcursions } from './module'

class AllDirectionsExcursionsStore {
  allDirectionsExcursion: PopularDirectionExcursions[] | null = null

  constructor() {
    makeAutoObservable(this)
  }

  async fetchAllDirections() {
    try {
      const { data: allExcursions } =
        await MainPageExcursions.getPromotions(false)

      this.allDirectionsExcursion = allExcursions.data
    } catch (error) {
      console.error('Failed to fetch popular directions:', error)
    }
  }

  setAllDirections(data: PopularDirectionExcursions[] | null) {
    this.allDirectionsExcursion = data
  }

  getAllDirections() {
    return toJS(this.allDirectionsExcursion)
  }
}

export const allDirectionsExcursionsStore = new AllDirectionsExcursionsStore()
